var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JUNE_ICONS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m66.63,24.31l-.17-.19-.05-.02c-7.09-6.91-18.49-6.86-25.52.14l-3.25,3.24-1.29,1.34v-11.37h-2.3v15.4l15.47-.04v-2.3s-11.64.03-11.64.03l1.4-1.46,3.23-3.22c6.18-6.16,16.24-6.16,22.47.05h0c2.96,2.98,4.59,6.92,4.59,11.12s-1.57,8-4.5,11.02l-.15.15c-6.18,6.16-16.24,6.16-22.42,0-5.09-5.07-10.19-10.15-10.19-10.15l-10.19-10.15c-5.04-5.02-13.25-5.02-18.29,0l-.34.34h0C1.27,30.66.05,33.75.05,37.04s1.21,6.34,3.46,8.77l.34.36c5.04,5.02,13.25,5.02,18.29,0l2.91-2.9-1.62-1.63-2.91,2.9c-4.1,4.09-10.75,4.13-14.91.14l-.15-.15c-2.01-2-3.11-4.66-3.11-7.49s1.11-5.49,3.06-7.44l.4-.35v-.03c4.17-3.81,10.67-3.7,14.71.32l10.19,10.15s5.09,5.08,10.19,10.15c3.54,3.53,8.2,5.3,12.85,5.29,4.59,0,9.17-1.72,12.67-5.15l.16-.15c3.43-3.42,5.32-7.96,5.32-12.79s-1.89-9.37-5.25-12.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.5b34e5373cd513d38b4f2e64f8eacc40.svg";
export { ForwardRef as ReactComponent };